import { render, staticRenderFns } from "./uploadStory.vue?vue&type=template&id=5d87f69b&"
import script from "./uploadStory.vue?vue&type=script&lang=js&"
export * from "./uploadStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports